import { useMemo } from 'react';

import { useEventsInfoWithFilteredPlayersQuery } from '@/api/events/query.generated';
import { mapFeedEntryToBetslipPick } from '@/feature/betslip-pickem/utils/betslip-utils';
import { useEventPlayerIds } from '@/feature/entries-pickem/hooks/use-event-player-ids';
import { RaceToPlaceEntry } from '@/types/socialFeed.generated';

export const useRaceToPlacePicks = (raceToPlaceEntry: RaceToPlaceEntry) => {
    const { eventIds, playerIds } = useEventPlayerIds(raceToPlaceEntry.picks);

    const [{ data: eventsData }] = useEventsInfoWithFilteredPlayersQuery({
        variables: { eventIds, playerIds },
        pause: false,
    });

    const events = useMemo(() => eventsData?.getEventsWithFilteredPlayers ?? [], [eventsData]);

    const picks = useMemo(
        () => mapFeedEntryToBetslipPick(raceToPlaceEntry.picks, events),
        [events, raceToPlaceEntry.picks]
    );

    return { events, picks };
};
